const AppConstants = {
  // api: process.env.REACT_APP_DENSO_QA_SERVICE_LOCAL,
  // api: process.env.REACT_APP_DENSO_QA_SERVICE,
  // api:'http://ec2-52-66-191-205.ap-south-1.compute.amazonaws.com:8080'
  // api:'https://sterliteapi.dev.industrialdata.in',
  // api: 'http://43.205.216.116:8080'
  api: 'https://sterliteapi.dev.industrialdata.in'
  // api: 'https://sterliteapi.prod.industrialdata.in'
};

export default AppConstants;
